import type {
  InitializeChatRequest,
  InitializeChatResponse,
  SendMessageRequest,
  SendMessageResponse
} from './types';

export class ChatWidgetService {
  private apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl.replace(/\/$/, ''); // Remove trailing slash
  }

  async initializeChat(request: InitializeChatRequest): Promise<InitializeChatResponse> {
    const response = await fetch(`${this.apiUrl}/api/public/chat/initialize`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      throw new Error(`Failed to initialize chat: ${response.statusText}`);
    }

    return response.json();
  }

  async sendMessage(request: SendMessageRequest): Promise<SendMessageResponse> {
    const response = await fetch(`${this.apiUrl}/api/public/chat/message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      if (response.status === 429) {
        throw new Error('Превышен лимит запросов. Пожалуйста, попробуйте позже.');
      }
      throw new Error(`Failed to send message: ${response.statusText}`);
    }

    return response.json();
  }
}
